import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetDashboard,
  cleanUpDashboard,
  cleanUpMessageDashboard
} from 'state-managament/dashboard.slice';

export default function useDashboard(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpDashboard());
  const cleanUpMessage = () => dispatch(cleanUpMessageDashboard());
  const getDashboard = (args) => dispatch(fetchGetDashboard(args));


  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getDashboard,
  };

}
